// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import { canPlay, MATCH_URL_DAILYMOTION } from '../../../constants';
import { defaultProps } from '../props';
import type { BaseReactPlayerProps } from '../types';
import { callPlayer, getSDK, parseStartTime } from '../utils';

const SDK_URL = 'https://api.dmcdn.net/all.js';
const SDK_GLOBAL = 'DM';
const SDK_GLOBAL_READY = 'dmAsyncInit';

export class DailyMotion extends Component<BaseReactPlayerProps> {
  static defaultProps = defaultProps;

  static canPlay = canPlay.dailymotion;
  static loopOnEnded = true;

  callPlayer = callPlayer;

  load(url) {
    const [, id] = url.match(MATCH_URL_DAILYMOTION);

    if (this.player) {
      this.player.load(id, {
        start: parseStartTime(url),
        autoplay: this.props.playing
      });
      return;
    }

    getSDK(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, (DM) => DM.player).then(
      (DM) => {
        if (!this.container) return;
        const {
          controls,
          config,
          onSeek,
          onEnded,
          onPause,
          onPlay,
          onError,
          onBuffer,
          onReady,
          playing,
          muted
        } = this.props;

        const Player = DM.player;

        this.player = new Player(this.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: {
            controls,
            autoplay: playing,
            mute: muted,
            start: parseStartTime(url),
            origin: window.location.origin,
            ...config.dailymotion.params
          },
          events: {
            apiready: onReady,
            seeked: () => onSeek(this.player.currentTime),
            video_end: onEnded,
            durationchange: this.onDurationChange,
            pause: onPause,
            playing: onPlay,
            waiting: onBuffer,
            error: (event) => onError(event)
          }
        });
      },
      this.props.onError
    );
  }

  onDurationChange = () => {
    const { onDuration } = this.props;
    const duration = this.getDuration();

    onDuration?.(duration);
  };

  play() {
    this.callPlayer('play');
  }

  pause() {
    this.callPlayer('pause');
  }

  stop() {
    // Nothing to do
  }

  seekTo(seconds) {
    this.callPlayer('seek', seconds);
  }

  setVolume(fraction) {
    this.callPlayer('setVolume', fraction);
  }

  mute = () => {
    this.callPlayer('setMuted', true);
  };

  unmute = () => {
    this.callPlayer('setMuted', false);
  };

  getDuration() {
    return this.player.duration || null;
  }

  getCurrentTime() {
    return this.player.currentTime;
  }

  getSecondsLoaded() {
    return this.player.bufferedTime;
  }

  ref = (container) => {
    this.container = container;
  };

  render() {
    const style = {
      width: '100%',
      height: '100%'
    };

    return (
      <div style={style}>
        <div ref={this.ref} />
      </div>
    );
  }
}
